<template>
      <div class="main-box main-content">
          <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" height="400px" :close-on-click-modal="false" >
                <el-form ref="dataForm" id="dataForm" :model="temp" label-width="180px" label-suffix="：">
                     <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="电子签约生效日期">
                              <el-checkbox v-model="temp.nextMonthEffective" :true-label="1" :false-label="0">下月1号生效</el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                              <xr-button type="primary" @click.native="save">确定</xr-button>
                            </el-form-item>
                        </el-col>
                     </el-row>
                    <el-row :gutter="24">
                      <el-col :span="12">
                        <el-form-item label="身份证阅读机具">
                          <el-select v-model="temp.idCardUse" placeholder="请选择">
                            <el-option v-for="item in idCardUseList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item>
                          <xr-button type="primary" @click.native="save2">确定</xr-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                     <xr-button type="default" @click.native="dialogVisible = false">关闭</xr-button>
                </div>
          </el-dialog>
      </div>
</template>

<script>
  export default {
    name: 'personSetting',
    data() {
      return {
        dialogVisible: false,
        dialogName: '偏好设置',
        idCardUseList: [
          {
            id: 1,
            name: '神思电子'
          },
          {
            id: 2,
            name: '华视电子'
          }
        ],
        temp: {
            nextMonthEffective: 0,
            idCardUse: 1,
        }
      }
    },
    methods: {
      init() {
        this.dialogVisible = true;
        // 电子签约生效日期设置
        const savedValue = localStorage.getItem('electronicSignPersonSetting');
        const idCardUse = localStorage.getItem('idCardUse');
        if (savedValue !== null) {
          this.temp.nextMonthEffective = parseInt(savedValue);
        }
        if (idCardUse !== null) {
          this.temp.idCardUse = parseInt(idCardUse);
        }
      },
      save(){
        localStorage.setItem('electronicSignPersonSetting', this.temp.nextMonthEffective.toString());
        this.$message({
          message: '操作成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.dialogVisible = false;
            this.$emit("saveSuccess");
          }
        })
      },
      save2(){
        localStorage.setItem('idCardUse', this.temp.idCardUse.toString());
        this.$message({
          message: '操作成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.dialogVisible = false;
            this.$emit("saveSuccess");
          }
        })
      },
      resetTemp(){
        this.temp.nextMonthEffective =0
        this.temp.idCardUse = 1
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/common/person-setting.vue